import { css } from '@emotion/css'
import { fontFamily, fontSize, spacing } from '../../styles'
import getThemeColors, { colors } from '../../themes'

import { attachmentHeight } from '../Attachment'

const styles = {
  wrapper: css({
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    maxWidth: '100%',
  }),

  label: css({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: fontSize.default,
    fontFamily: fontFamily.body,
    lineHeight: 1,
    minHeight: attachmentHeight.small,

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  labelError: css({
    color: colors.mandy,
  }),

  labelText: css({
    '&:hover': {
      textDecoration: 'underline',
    },
  }),

  input: css({
    display: 'none',
  }),
}

export default styles

export const labelColor = theme => {
  if (theme === 'light') {
    return css({
      color: colors.jumbo,
    })
  }

  const themed = getThemeColors(theme)
  return css({
    color: themed.base,
  })
}
